// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"e7d693ad","281":"9ccdea11","635":"954e41e0","787":"cef641ea","825":"7cbb9788","885":"cb287d42"}[chunkId] + ".chunk.js";
};